export default {
    // --------Title--------
    selectSearchLocation: 'Select Search Location',
    youCanSelectMultipleWarehouseLocationsToProceed: 'You can select multiple warehouse locations to proceed',
    advancedFilters: 'Advanced Filters',
    dataFilters: 'Data Filters',
    multipleFiltersApplyToDatasetResults: 'Multiple filters apply to dataset results',
    scopeTheRangeOfTheSearchLocations: 'Scope the range of the search locations',
    deliveryReport: 'Delivery',

    productItemReport: 'Product Item Report',
    salesOrderReport: 'Sales Order Report',
    salesOrderItemReport: 'Sales Order Item Report',
    deliveryOrderReport: 'Delivery Order Report',
    deliveryOrderItemReport: 'Delivery Order Item Report',
    itemReceiveReport: 'Item Receive Report',
    itemReceiveItemReport: 'Item Receive Item Report',
    itemTransferReport: 'Item Transfer Report',
    itemTransferItemReport: 'Item Transfer Item Report',
    stockValueReport: 'Stock Value Report',

    basicSearch: 'Basic Search',
    filterDataForBasicInformation: 'Filter data for basic information',
    advancedFilter: 'Advanced Filter',
    filterDataForAdvancedInformation: 'Filter data for advanced information',

    // --------MUI--------
    createDateFrom: 'Create Date From',
    createDateTo: 'Create Date To',
    profileName: 'Profile Name',
    deliveryProfileName: 'Delivery Profile Name',
    billingProfileName: 'Billing Profile Name',
    supplierProfileName: 'Supplier Profile Name',
    resetFilter: 'Reset Filter',

    any: 'Any',
    documentStatus: 'Document Status',
    applyFilters: 'Apply Filters',
    approval: 'Approval',
};